import { ServiceType } from "../enums/service-type";
import { SearchCriteria } from "./search-criteria";

export class ServiceBranchSearchCriteria extends SearchCriteria {

    public ServiceTypes:ServiceType[];
    
}
